import { createReducer , on } from '@ngrx/store';
import { UserInfo } from 'src/app/models/users/user.models';
import { addUser, removeUser } from '../../actions/user/user.actions';

export interface userState {
    User: UserInfo
}

export const initialUserEntries : UserInfo = {} ;

export const UserReducer = createReducer(
    
    initialUserEntries,

    on(addUser , (entries , User) => User),
    
    on(removeUser , (EmptyObject) => {
        const entriesClone : UserInfo = EmptyObject;
        return entriesClone;
    })
)